import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  ISidebarMenu,
  ISidebarPageInfo,
  ISidebarUser,
} from "./sidebar-header.interfaces";


const SidebarHeaderConsts = {
  defaultTitle: "",
  storageName: "sidebarIsCollapsed",
};

@Component({
  selector: "app-sidebar-header",
  templateUrl: "./sidebar-header.component.html",
  styleUrls: ["./sidebar-header.component.scss"],
})
export class SidebarHeaderComponent implements OnInit, OnChanges {
  menu: ISidebarMenu[] = [
    // { label: "INÍCIO", route: "/", nzIconType: 'home' },
    { label: "CONSULTAR", nzIconType: 'file-add', route: '/consultar-certidao' }
    //{ label: "AÇÃO COLETIVA", route: 'acao-coletiva' }
  ];
  @Input() notifications: number = 0;
  @Input() pageInfo: ISidebarPageInfo = null;
  @Input() user: ISidebarUser = null;

  @Output() sendLogout: EventEmitter<any> = new EventEmitter<any>();

  sidebarCollapsed: boolean = false;
  title: string = "";

  menuHome: ISidebarMenu = { label: "CONSULTAR", route: "consultar-certidao" };


  private rexBreakLine = /<br>|<br(\s*)?\/>/gi;

  constructor() {
    this.checkSidebar();
  }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges) {
    this.atChangeInputPageInfo(changes);
  }

  atChangeInputPageInfo(changes: SimpleChanges) {
    if (changes && changes.pageInfo) {
      const info = changes.pageInfo.currentValue;
      if (info) {
        this.title = info.title ? info.title : "";
      }
    }
  }

  atMenuClick(e) {
    e.stopPropagation();
  }

  atSidebarClick() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    window.localStorage.setItem(
      SidebarHeaderConsts.storageName,
      this.sidebarCollapsed + ""
    );
  }

  checkSidebar(): void {
    setTimeout(() => {
      const collapsed: string = window.localStorage.getItem(
        SidebarHeaderConsts.storageName
      );
      this.sidebarCollapsed = collapsed === "true";
    });
  }

  logout() {
    this.sendLogout.emit();
  }

  selectMenu(item: ISidebarMenu, testAtEnd = false): boolean {
    if (item) {
      if (item.submenu && item.submenu.length) {
        let childMatchesRoute = false;

        if (!item.route) {
          return item.submenu.some((child) => this.selectMenu(child));
        }

        item.submenu.forEach((child) => {
          if (child && child.route) {
            childMatchesRoute = item.submenu.some((child) =>
              this.selectMenu(child)
            );
          }
        });

        return childMatchesRoute;
      }

      if (item.route) {
        return this.testRouteMatch(item.route, testAtEnd);
      }
    }
    return false;
  }

  testRouteMatch(route: string, testAtEnd = false): boolean {
    const treatedRoute = route.match(/^\//gi) ? route : `/${route}`;
    // console.log("route", route);
    // console.log("treatedRoute", treatedRoute);
    const rex = new RegExp(`#${route}` + (testAtEnd ? "$" : ""), "gi");
    // console.log("location.hash", location.hash);
    // console.log(
    //   "window.location.hash.match",
    //   !!window.location.hash.match(rex)
    // );
    return !!window.location.hash.match(rex);
  }

  treatText(str: string): string {
    if (str.match(this.rexBreakLine)) {
      return `<strong>${str.replace(
        this.rexBreakLine,
        "</strong><strong>"
      )}</strong>`;
    }
    return str;
  }

  insertTitle(title: string) {
    //console.log("title", title);

    // setTimeout(() => {
    //   this.pagesStore.dispatch(
    //     pagesActions.setPageInfo({
    //       pageInfo: {
    //         title: title,
    //       },
    //     })
    //   );
    // });
  }
}
